// Enterprises with the Grades delivery model call their trainers "teachers": every label is rewritten on the fly.
import { useSyncExternalStore } from "react";

let on = false;
const subs = new Set();
export const setTeacherMode = (v) => { if (on !== !!v) { on = !!v; subs.forEach((f) => f()); } };
export const useTeacherMode = () => useSyncExternalStore((f) => { subs.add(f); return () => subs.delete(f); }, () => on, () => on);

const EN = [[/\bTrainers\b/g, "Teachers"], [/\bTrainer\b/g, "Teacher"], [/\btrainers\b/g, "teachers"], [/\btrainer\b/g, "teacher"]];
const AR = [[/المدرّب/g, "المعلّم"], [/مدرّب/g, "معلّم"], [/المدرب/g, "المعلم"], [/مدرب/g, "معلم"]];
export const teacherize = (s, lang) => {
  if (!on || typeof s !== "string") return s;
  return (lang === "ar" ? AR : EN).reduce((x, [re, to]) => x.replace(re, to), s);
};
